
import { Options, Vue } from "vue-class-component";
import { OfficeFlow, FlowValidate, Popup, Toast } from "../packages";
import chooseApproval from "./components/choose-approval.vue";
import chooseCondition from "./components/choose-condition.vue";
import ClipboardJS from "clipboard";
new ClipboardJS(".copybtn");

@Options({
  components: {
    OfficeFlow: OfficeFlow,
    Popup,
    chooseApproval,
    chooseCondition,
  },
})
export default class ScorePage extends Vue {
  // 原始数据
  cnode = {
    name: "提交人",
    type: "start",
    nodeName: "",
    properties: {
      // 数据可以存放到properties对象里面
    },
  };

  // 添加节点的时候有哪些项目
  adddata = [
    { key: "approver", value: "审批人", icon: "Stamp", color: "#3d91eb" },
    {
      key: "notifier",
      value: "抄送人",
      icon: "Promotion",
      color: "orange",
    },
    { key: "hehe", value: "呵呵", icon: "UserFilled", color: "blue" },
    { key: "lala", value: "拉拉", icon: "StarFilled", color: "green" },
    { key: "condition", value: "条件分支", icon: "Branch", color: "#333" },
  ];

  // 交互相关
  popupshow = false;
  nodeData: any = {};
  conditionsData: any[] = [];

  // 提交校验
  onSubmit() {
    FlowValidate(this.cnode)
      .then((ret) => {
        console.log("validate success!");
        console.log(this.cnode);
      })
      .catch((err) => {
        console.log(err);
        Toast({
          allowHtml: true,
          message: `${!err.ValidateNodeNames ? "存在空节点,请补充<br/>" : ""} ${
            !err.flows ? "存在没有审批人的流程!" : ""
          }`,
        });
      });
  }

  // 选择节点,打开弹出层
  onChoose({ type, node, conditions }: any) {
    this.popupshow = true;
    this.nodeData = node;
    this.conditionsData = conditions;
  }

  // 添加节点
  onAdd({ type, node }: any) {
    //
  }
}
